<template>
    <div>
      <a-card
        hoverable
        :bordered="false"
        class="header-solid h-full mb-50"
        :bodyStyle="{ paddingTop: '12px' }"
      >
        <template #title>
          <a-row>
            <a-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
              <h6>
                <a @click="goToMainPage" class="mr-5"><a-icon type="arrow-left" /></a> Choose a  booking type to be processed</h6>
            </a-col>
            <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4"></a-col>
          </a-row>
        </template>
        <!-- card-Type -->
        <a-row class="mb-50">
          <a-col
            v-for="(item, cardtype) in dataCardRequest"
            :key="'type' + cardtype"
            :xs="24"
            :sm="24"
            :md="{ span: 22, offset: 1 }"
            :lg="{ span: 6, offset: 1 }"
            :xl="{ span: 6, offset: 1 }"
          >
            <div v-if="item.onProd" class="gutter-box">
              <a-card @click="gotoFormRequest(item.path)" hoverable class="mb-20">
                <template slot="actions" class="ant-card-actions">
                  <a-icon
                    key="edit"
                    type="edit"
                  />
                </template>
                <a-card-meta>
                  <span slot="title">
                    
                    <p :class="item.value === 'Z' ? 'f-18' : 'f-18'" class="mt-15 font-bold font-web">{{ item.headText }}</p>
                  </span>
                  <a-avatar
                    slot="avatar"
                    shape="square"
                    :size="64"
                    :icon="item.icon"
                    :style="{
                      backgroundColor: item.color,
                      verticalAlign: 'middle',
                    }"
                  />
                </a-card-meta>
              </a-card>
            </div>
          </a-col>
        </a-row>
      </a-card>
    </div>
  </template>
  <script>
  import cardContent from "./PrBookingItem.js"
  export default {
    data() {
      return {
        dataCardRequest: cardContent.items,
      };
    },
    methods: {
      goToMainPage() {
      this.$router
        .push({
          path: "/booking/",
        })
        .catch((err) => { });
    },
      gotoMainRequest() {
        this.$router
          .push({
            path: "/hri",
          })
          .catch((err) => {});
      },
      gotoFormRequest(pathUrl) {
        this.$router
          .push({
            path: pathUrl,
          })
          .catch((err) => {});
      },
    },
  };
  </script>
  
  <style scoped>
  .f-20 {
    font-size: 20px;
  }
  .f-18 {
    font-size: 18px;
  }
  </style>